<p-toast #toast [preventOpenDuplicates]="true"></p-toast>
<p-confirmDialog closeOnEscape="false" /> <!-- we use this when cancel a request -->
<app-version-badge />
<router-outlet></router-outlet>
